import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { fuseAnimations } from '@fuse/animations';
import { FuseUtils } from '@fuse/utils';

import { ScrumboardService } from '../../../../scrumboard.service';
import { ParseService } from 'app/shared/common/parse/parse.service';

@Component({
    selector: 'scrumboard-label-selector',
    templateUrl: './label-selector.component.html',
    styleUrls: ['./label-selector.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})

export class ScrumboardLabelSelectorComponent implements OnInit, OnDestroy {

    @Input('card')
    card: any;
    @Output()
    cardLabelsChanged: EventEmitter<any>;
    board: any;
    labelsMenuView: string;
    selectedLabel: any;
    newLabel: any;
    toggleInArray: any;
    role = [];
    boards: any;
    private _unsubscribeAll: Subject<any>;
    array: any[];
    projectMemberRole = [];

    /**
     * Constructor
     *
     * @param {ScrumboardService} _scrumboardService
     */
    constructor(
        private _scrumboardService: ScrumboardService,
        private parseService: ParseService,
    ) {
        // Set the defaults
        this.cardLabelsChanged = new EventEmitter();
        this.labelsMenuView = 'labels';
        this.newLabel = {
            id: '',
            name: '',
            color: 'blue-400'
        };
        this.toggleInArray = FuseUtils.toggleInArray;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this._scrumboardService.onBoardChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(board => {
                this.board = board;
            });


        this._scrumboardService.onBoardChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(board => {
                this.boards = board;
                let project = this.boards.project;
                let projectId = project.id;
                this.getRoles(projectId);
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Card labels changed
     */
    onCardLabelsChanged(): void {

        this.cardLabelsChanged.next();
    }

    /**
     * On label change
     */
    onLabelChange(): void {
        this._scrumboardService.updateBoard();
    }

    /**
     * Add new label
     */
    addNewLabel(): void {
        this.newLabel.id = FuseUtils.generateGUID();
        if (!this.board.labels) {
            this.board.labels = [];
        }
        this.board.labels.push(Object.assign({}, this.newLabel));
        this.newLabel.name = '';
        this.labelsMenuView = 'labels';
    }


    async getRoles(projectId) {
        this.role = [];
        let array = [];
        let ProjectMembers = this.parseService.instance.Object.extend('ProjectMembers');
        let projectMembers = new this.parseService.instance.Query(ProjectMembers);
        projectMembers.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: projectId });
        let res = await projectMembers.find();
        this.projectMemberRole = [];
        res.forEach(element => {
            if (element.attributes.role !== ''){
            if (this.projectMemberRole.includes(element.attributes.role) !== true){
                this.projectMemberRole.push(element.attributes.role);
            }
            }
        });

        let queryInstance = this.parseService.instance.Object.extend('DataSettings');
        let query = new this.parseService.instance.Query(queryInstance);
        let results = await query.find();
        let role = results[0].attributes.resourceRole;
        // const roles = role.filter(e => this.projectMemberRole.includes(e));
        const roles = this.projectMemberRole;
        roles.forEach(innerElement => {
            array.push({
                id: this.getRandomNumber(9),
                taskRole: innerElement
            });
        });
        this.role = array.filter((x, i, a) => a.indexOf(x) == i);
    }

    getRandomNumber(val) {
        let timestamp = +new Date();
        length = val;
        var ts = timestamp.toString();
        var parts = ts.split("").reverse();
        var id = "";

        for (var i = 0; i < length; ++i) {
            var index = this.generateRandomNumber(0, parts.length - 1);
            id += parts[index];
        }
        return id;
    }

    generateRandomNumber(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
}
